import React, { useState, useEffect } from 'react';
import SalesTable from './salestable';
import constant from '../../constant';

const SalesContent = () => {
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [salesFreezePeriodStart, setSalesFreezePeriodStart] = useState(false);
  const [salesFreezePeriodEnd, setSalesFreezePeriodEnd] = useState(false);
  const [error, setError] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState({
    from: new Date(new Date().getFullYear(), 0, 1), // Default: Start of the year
    to: new Date(), // Default: Today
  });

  useEffect(() => {
    const fetchSales = async () => {
      const token = localStorage.getItem('token');
      const userRole = localStorage.getItem('role');
      const adminSelectedUser = localStorage.getItem('adminSelectedUser');

      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      // Function to format date to DD-MM-YYYY
      const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      };

      const startDate = formatDate(selectedPeriod.from);
      const endDate = formatDate(selectedPeriod.to);

      // Construct API URL with date range
      let apiUrl = `${constant.REACT_APP_API_URL}/sales?startDate=${startDate}&endDate=${endDate}`;

      if (userRole === 'admin' && adminSelectedUser) {
        apiUrl += `&userId=${adminSelectedUser}`;
      }

      try {
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();

        if (response.ok) {
          setSales(result.data.salesData);
      
            setSalesFreezePeriodStart(new Date(result.data.freezePeriodStart));
            setSalesFreezePeriodEnd(new Date(result.data.freezePeriodEnd));
        } else {
          setError(result.message || 'Failed to fetch sales');
        }
      } catch (error) {
        setError('Error fetching sales');
      } finally {
        setLoading(false);
      }
    };

    fetchSales();
  }, [selectedPeriod]); // Dependency on selectedPeriod to refetch when dates change

  const handleDelete = (id) => {
    setSales(sales.filter((sale) => sale._id !== id));
  };

  const handleEdit = (saleId, newIsActiveStatus) => {
    setSales(prevSales => {
      return prevSales.map(sale => {
        if (sale._id === saleId) {
          return { ...sale, isActive: newIsActiveStatus };
        }
        return sale;
      });
    });
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="px-6 pt-16 md:pt-0">
      <div className="">
        <div className="">
          <SalesTable
            sales={sales}
            onDelete={handleDelete}
            onEdit={handleEdit}
            selectedPeriod={selectedPeriod}
            setSelectedPeriod={setSelectedPeriod}
            salesFreezePeriodStart={salesFreezePeriodStart}
            salesFreezePeriodEnd={salesFreezePeriodEnd}
          />
        </div>
      </div>
    </div>
  );
};

export default SalesContent;